export default function isSearchHash(hash) {
    hash = decodeURI(hash);
    var match = /#search\/(\d{4}-\d{2}-\d{2})\/(\d{4}-\d{2}-\d{2})\/(\d)+\/?(\w+ - \w+)?\/?(\w+)?\/?(\w+)?/.exec(hash)
    if (match != null && match.length > 2) {
        return true;
    }
    return false;
}